module.exports = __webpack_public_path__ + "static/media/katieTeletraining_mobile.cc7028e6.jpg";